export default {
  login(name: string, email: string) {
    return
    /**
     * Slack webhook has been disabled. Phase I of deprecation.
     */
    // const url = process.env.VUE_APP_SLACK_WEBHOOK;
    // return fetch(url, {
    //   method: "POST",
    //   body: JSON.stringify({
    //     text: `${name} ${email}`
    //   })
    // });
  }
} 